import React from "react";

const ConfirmModal = ({ show, onClose, onConfirm, message, confirmButtonText = "Yes, Delete", cancelButtonText = "Cancel", title = "Confirm Action" }) => {
  return (
    <div
      className={`modal fade ${show ? "show d-block" : "d-none"}`}
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.5)", zIndex: 1060 }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-header bg-light border-0">
            <h5 className="modal-title fw-bold">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body py-4">
            <p
              className="mb-0 fs-5 text-center"
              dangerouslySetInnerHTML={{ __html: message || "Are you sure you want to proceed?" }}
            />
          </div>
          <div className="modal-footer border-0 bg-light">
            <button className="btn btn-outline-secondary px-4" onClick={onClose}>
              {cancelButtonText}
            </button>
            <button 
              className={`btn ${confirmButtonText.includes('Delete') ? 'btn-danger' : 'btn-primary'} px-4`} 
              onClick={onConfirm}
            >
              {confirmButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
